export default {
  notifications: [],
  tenants: [],
  tenant: {},
  user: {},
};
